export const emailOptions = {
  Always: 'Always',
  OnChangeOrError: 'OnChange, OnError',
  OnError: 'OnError',
  None: 'None',
};

export const scopeOptions = {
  Selected: 0,
  AllEnabled: 1,
  AllButRemoved: 2,
};

export const entityRelatedOptions = {
  EnabledStatusFilterValue: {
    Campaign: ['121', '126'],
    Ad: ['1'],
    AdGroup: ['141', '126'],
    Keyword: ['161'],
    AssetGroup: ['141'],
  },
  EnabledStatusFilterQueryOdata: {
    AdGroup: "Status eq Enum.AdGroupStatus'Active' or Status eq Enum.AdGroupStatus'CampaignBudgetPaused'",
    Ad: "Status eq Enum.AdStatus'Active'",
    Campaign: "Status eq Enum.CampaignStatus'Active' or Status eq Enum.CampaignStatus'BudgetPaused'",
    Keyword: "Status eq Enum.OrderItemStatus'Active'",
    AssetGroup: "Status eq Enum.AssetGroupStatus'Active'",
  },
  EnabledStatusFilterColumn: {
    Campaign: 'CampaignStatus',
    Ad: 'AdUiDisplayStatus',
    AdGroup: 'AdGroupStatus',
    Keyword: 'KeywordStatus',
    AssetGroup: 'AssetGroupStatus',
  },
};
